import axios from 'axios';

const API_URL = 'https://dev.paron-card.gr';
// const API_URL = 'https://127.0.0.1:8000';
const formDataHeaders = {
    'Content-Type': 'multipart/form-data'
}

export default {
    post(urlPath, data, headers) {
        return this.request(urlPath, headers, 'POST', data);
    },
    get(urlPath) {
        return this.request(urlPath, null, 'GET', null);
    },
    postFormData(urlPath, formData) {
        return this.request(urlPath, 'POST', formDataHeaders, formData)
    },
    request(urlPath, headers, method, data) {
        method = method || 'POST';
        data = data || {};
        headers = headers || {};
        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + urlPath,
                data,
                method,
                headers
            })
                .then(function(response) {
                    let contetType = response.headers['content-type'];
                    if (contetType && contetType.indexOf('application/json') > -1) {
                        return response.data;
                    } else {
                        resolve();
                    }
                })
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    if (!error.response) {
                        // eventBus.$emit('sessionExpired');
                    }
                    reject(error);
                });
        });
    }
};
